<template>
    <section class="comp_checkin_home">
        <div class="comp_scroller">
            <div class="comp_content">
                <div class="wrp_comp_wip">
                    {{ $t('preparing') }}
                </div>
                <!--header class="wrp_comp_header mod--row mod--row-flex mod--row-middle">
                  <div class="col">
                    <h1 class="part_ui_heading"><span>{{$t("arrivals")}}: {{count}}</span></h1>
                  </div>
                  <div class="col mod--flex-grow mod--right">
                    <router-link to="/search"><span class="icon icon--search"></span></router-link>
                  </div>
                </header>
                <div class="wrp_comp_body">
                  <div class="mod--row mod--row-4">
                    <div class="col col--12">
                      <router-link to="/check-in/new" class="elm_new">
                        <span>{{$t('accept_without_booking')}}</span>
                      </router-link>
                    </div>
                    <div class="col col--12" v-for="item in checkins">
                      <part-reservation v-bind="item"></part-reservation>
                    </div>
                  </div>
                </div-->
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'checkin-home',
    data() {
        return {
            count: 25,
            checkins: [
                {
                    roomName: 'DBL 1/2',
                    personName: 'Arnošt Lustig',
                    groupName: 'CK Tip',
                    arrival: '31.11',
                    departure: '12.12',
                    price: 560,
                    currency: ',- EUR',
                    url: '/check-in/edit'
                },
                {
                    id: 101,
                    roomName: 'DBL 1/2',
                    personName: 'Bohumil Hrabal',
                    arrival: '31.11',
                    departure: '12.12',
                    url: '/check-in/edit'
                },
                {
                    id: 101,
                    roomName: 'DBL 1/2',
                    personName: 'Arnošt Arnošt Lustig',
                    groupName: 'Nazev skupiny',
                    arrival: '31.11',
                    departure: '12.12',
                    icons: ['icon--card'],
                    url: '/check-in/edit'
                },
                {
                    id: 101,
                    roomName: 'DBL 1/2',
                    personName: 'Bohumil Hrabal',
                    arrival: '31.11',
                    departure: '12.12',
                    url: '/check-in/edit'
                },
                {
                    id: 101,
                    roomName: 'DBL 1/2',
                    personName: 'Bohumil Hrabal',
                    arrival: '31.11',
                    departure: '12.12',
                    url: '/check-in/edit'
                },
                {
                    id: 101,
                    roomName: 'DBL 1/2',
                    personName: 'Bohumil Hrabal',
                    arrival: '31.11',
                    departure: '12.12',
                    url: '/check-in/edit'
                },
                {
                    id: 101,
                    roomName: 'DBL 1/2',
                    personName: 'Bohumil Hrabal',
                    arrival: '31.11',
                    departure: '12.12',
                    url: '/check-in/edit'
                },
            ]
        }
    },
    mounted() {

    }
}
</script>



// WEBPACK FOOTER //
// src/templates/comp/checkin-home.vue